import Vue from 'vue'

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * send consolidated for quotation
 */

const sendConsolidated = (payload) =>
  Vue.$http.post(`purchase/quotation-requisition/`, payload)
    .then()
    .catch(err => {
      throw err
    })

export default sendConsolidated


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/sendConsolidated.js